import { Map, Record } from "immutable";

import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates";

import { userStatsFetchStateConfig } from "../../../consts";
import UserStat, { RecentlyStudiedCourse } from "./stat";

export { UserStat, RecentlyStudiedCourse };
export type {
  RecentlyStudiedCourseType,
  UserStatType,
  UserStatServerType,
  RecentlyStudiedCourses
} from "./stat";

export type UserStatStateSliceType = {
  stats: UserStat;
  meta: CrudBuilderState | Map<any, any>;
};

const userStatsMetaInitialState = makeCrudBuilderInitialState(
  userStatsFetchStateConfig
);

const defaultValues: UserStatStateSliceType = {
  stats: new UserStat(),
  meta: userStatsMetaInitialState
};

export default class UserStatStateSlice extends Record(defaultValues) {}
